import { gql } from '@apollo/client';

export const SAVE_GENERIC_FILTER_TEMPLATE_GENERAL_DATA = gql`
  mutation saveGenericFilterTemplateGeneralData($input: GenericDocumentTemplateGeneralDataInput!) {
    saveGenericFilterTemplateGeneralData(input: $input) {
      commandId
      correlationId
    }
  }
`;

export const SAVE_GENERIC_FILTER_TEMPLATE_DETAILS = gql`
  mutation saveGenericFilterTemplateDetails($input: GenericDocumentTemplateDetailsInput!) {
    saveGenericFilterTemplateDetails(input: $input) {
      commandId
      correlationId
    }
  }
`;
